// The library's four-tab switcher.
//
// A thin binding of the shared `PillTabBar` to the library's own tab vocabulary — the
// control itself (pill group, arrow-key roving focus, mobile scroller) lives there so My
// Books renders the identical thing rather than a second copy of it.

import { PillTabBar } from "../../components/PillTabBar";
import type { LibraryTab } from "../../lib/library-types";
import { LIBRARY_TABS, TAB_LABEL } from "./tabs";

interface LibraryTabBarProps {
  active: LibraryTab;
  onChange: (tab: LibraryTab) => void;
  /** The mono line under the pills. */
  meta: string;
  /** Fires on hover/focus so the parent can prefetch that tab's chunk. */
  onIntent?: (tab: LibraryTab) => void;
}

export function LibraryTabBar({ active, onChange, meta, onIntent }: LibraryTabBarProps) {
  return (
    <PillTabBar
      idPrefix="lib"
      ariaLabel="Library sections"
      // No counts: a shelf tab is a place, not a quantity of things.
      tabs={LIBRARY_TABS.map((tab) => ({ key: tab, label: TAB_LABEL[tab] }))}
      active={active}
      onChange={onChange}
      meta={meta}
      onIntent={onIntent}
    />
  );
}
